/**
 * The Reach's side of the contract boards (M3 plan §7 item 4, slice R22g). M2's generator issues three more types
 * when the career runs in the Reach: lane repair, relay parts delivery and chart a system. What they can target comes
 * from the Reach runtime through this seam: the M2 bridge (`src/bridge/m2/contracts.ts`) binds a source while the
 * career runs in the Reach, and without one (the M2 career alone, sandbox, tests) the three types are never issued,
 * so M2's boards stay exactly as before.
 *
 * Every list is the current system's (M2's station list follows the system, D-TBD 50), in a stable order, so the
 * same Reach state gives the same board. Career layer: not per-frame.
 */

/** A down lane ring a board may ask to repair. */
export interface ReachLaneRingJob {
  ringId: string
  systemId: string
  /** Credits the ring's repair parts are worth at the stand-in prices. */
  partsValue: number
  targetName: string
}

/** An offline relay still missing parts. */
export interface ReachRelayJob {
  relayId: string
  systemId: string
  /** Parts still missing, all kinds together (> 0). */
  missing: number
  /** Mean stand-in price of one missing part (credits). */
  unitValue: number
  targetName: string
}

/** A system not yet charted, `hops` relay hops from the station's system. */
export interface ReachChartJob {
  systemId: string
  hops: number
  targetName: string
}

export interface ReachContractSource {
  laneRings(): readonly ReachLaneRingJob[]
  relays(): readonly ReachRelayJob[]
  /** Uncharted systems 1..maxHops relay hops away. */
  charts(maxHops: number): readonly ReachChartJob[]
}

let bound: ReachContractSource | null = null

/** Binds the Reach's source (the bridge, once the career runs in the Reach); null unbinds it. */
export function bindReachContracts(source: ReachContractSource | null): void {
  bound = source
}

/** The bound source, or null outside the Reach. */
export function reachContractSource(): ReachContractSource | null {
  return bound
}
